import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Marquee from "react-fast-marquee";
import { useContext } from "react";
import TimerContext from "../../TimerContext/Timercontext";
import { useGetCurrency } from "../../BuyToken/api/buyTokenApi";
import Loader from "../../../Loader/buttonLoad";
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';

function SampleNextArrow(props) {

    const { onClick } = props;
    return (
        <button className="sldrRgtArr" onClick={onClick} />
    );
}

SampleNextArrow.propTypes = {
    onClick: PropTypes.any,
}

function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
        <button className="sldrLftArr" onClick={onClick} />
    );
}
SamplePrevArrow.propTypes = {
    onClick: PropTypes.any,
}
const Banner = ({ homepagedata, buy }) => {


    const { data: currency, isLoading } = useGetCurrency()
    const { t } = useTranslation()

    const { days, hours, minutes, seconds, visible } = useContext(TimerContext)
    let settings = {
       
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: false,
                }
            },
        ]
    }
    return (
        <div className="BnrSldr">

            <Slider {...settings}>
                <section className="BnrSec">
                    <div className='container'>
                        <div className="BnrSecDts">
                            <div className="row">
                                <div className="col-lg-6">

                                    <h5>{homepagedata?.banner_title}</h5>
                                    <p>{homepagedata?.banner_description}</p>
                                    <h1>$KKOG {t('COIN')}</h1>
                                    <div className="BnrPrSLvDv">
                                        <div className="Ldv">
                                            <h6><span>KKOG {t('COIN')}</span> {t('Presale is')} </h6>
                                            <h5>{t('Live')}</h5>
                                        </div>
                                        <button className="btn CmnBtn" onClick={buy}>{t('Buy Now')}<img src={require('../../../assets/images/cart.gif')} className='ml-3' alt='' width="23px" /></button>
                                    </div>

                                    {visible ? <div className='BnrTmr'>
                                        <div className="BnrTmrDv">
                                            <div className='Ldv'>
                                                <h4>{days}</h4>
                                                <h6>{t('Days')}</h6>
                                            </div>
                                            <div className='Rdv'>:</div>
                                            <div className='Ldv'>
                                                <h4>{hours}</h4>
                                                <h6>{t('Hours')}</h6>
                                            </div>
                                            <div className='Rdv'>:</div>
                                            <div className='Ldv'>
                                                <h4>{minutes}</h4>
                                                <h6>{t('Minutes')}</h6>
                                            </div>
                                            <div className='Rdv'>:</div>
                                            <div className='Ldv'>
                                                <h4>{seconds}</h4>
                                                <h6>{t('Seconds')}</h6>
                                            </div>
                                        </div>

                                    </div> : ""}









                                </div>
                                <div className="col-lg-6">
                                    <img src={homepagedata?.banner_image} alt='' className="BnrSecCnIg" />
                                </div>
                            </div>
                            <div className='BnrSpnSrDv'>
                                <span>{t('We Accept')}</span>
                                <div className="BnrSpnSrIGDv">
                                    <div className='BnrSpnSrIg'>
                                        <Marquee>
                                            {homepagedata?.paymentgateway.map((rowdata) => (
                                                <div className='BnrSpnSrIgDts' key={rowdata?._id}>
                                                    <img src={rowdata?.paymentimage} alt='' />
                                                </div>
                                            ))}
                                        </Marquee>
                                    </div>


                                </div>
                            </div>
                            <div className='BnrTkr'>
                                <Marquee>
                                    {isLoading ? <Loader /> : currency?.data.map((country) => (
                                        <div className='BnrTkrDts' key={country}>
                                            <img src={country?.currency_details?.image} alt='' />
                                            <span>{country?.currencyname}</span>
                                        </div>
                                    ))
                                    }


                                </Marquee>
                            </div>
                        </div>
                    </div>
                    <div className="BnrSecBrdBtm"></div>
                    <div className="BnrSecBrdRgt"></div>
                    <div className="BnrSecBrdRgtSml"></div>
                </section>



                <section className="BnrSec BnrRfrErnSec">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="BnrRfrErnDts">
                                <h1 dangerouslySetInnerHTML={{ __html: homepagedata?.banner_title_two }}></h1>
                                <p dangerouslySetInnerHTML={{ __html: homepagedata?.banner_description_two }}></p>
                                    <button className="btn CmnBtn">Buy KKOG Coin<img src={require('../../../assets/images/cart.gif')} className='ml-3' alt='' width="23px" /></button>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="BnrGlblChtDv">
                                    <img src={homepagedata?.banner_image_two} alt="" className="d-block mx-auto img-fluid GlbtCnrtIg" />
                                    <img src={homepagedata?.banner_image_four} alt="" className="d-block mx-auto img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="BnrRfrErnSec BnrSec">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="BnrRfrErnDts">
                                <h1 dangerouslySetInnerHTML={{ __html: homepagedata?.banner_title_three }}></h1>
                                    <button className="btn CmnBtn">Buy KKOG Coin<img src={require('../../../assets/images/cart.gif')} className='ml-3' alt='' width="23px" /></button>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="BnrGlblChtDv">
                                    <img src={homepagedata?.banner_image_three} alt="" className="d-block mx-auto img-fluid" />
                                    <img src={homepagedata?.banner_image_five} alt="" className="d-block mx-auto img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
            </Slider>
        </div>

    );

}
Banner.propTypes = {
    homepagedata: PropTypes.shape({
        banner_title: PropTypes.any,
        banner_description: PropTypes.any,
        banner_image: PropTypes.any,
        banner_image_two: PropTypes.any,
        banner_title_two: PropTypes.any,
        banner_description_two: PropTypes.any,
        banner_image_three: PropTypes.any,
        banner_title_three: PropTypes.any,
        banner_description_three: PropTypes.any,
        banner_image_five:PropTypes.any,
        banner_image_four:PropTypes.any,
        paymentgateway: PropTypes.arrayOf(
            PropTypes.shape({
                paymentimage: PropTypes.any,
            }))
    }),
    buy: PropTypes.any,
}

export default Banner;